import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Page Header (Text)",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/page-header-text", (props) => {
  return (
    <div className="w-full pt-10">
      <div className="w-grid mx-auto flex flex-col my-10 md:py-7 items-start justify-center gap-5">
        <EditableText
          as="h1"
          store="title"
          className="type-title-l md:type-title-xl text-balance"
          placeholder="Enter a title"
          data-transition="fade-up"
        />
        <EditableText
          as="h2"
          store="subtitle"
          className="type-label-s-caps"
          placeholder="Enter an optional subtitle"
          data-transition="fade-up"
        />
      </div>
    </div>
  )
})
